export default __webpack_public_path__ + "static/media/sport_class_params.b41aa7c7.png";